import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.95, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ eyebrow, title, lead, align = "left", testid }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <FadeUp>
      <p
        data-testid={testid}
        className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] text-brand-light"
      >
        {align !== "center" && <span className="h-px w-10 bg-brand-light" />}
        {eyebrow}
        {align === "center" && <span className="h-px w-10 bg-brand-light" />}
      </p>
    </FadeUp>
    <FadeUp delay={0.08}>
      <h2 className="mt-5 font-display text-3xl leading-[1.12] tracking-tight text-brand sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </FadeUp>
    {lead && (
      <FadeUp delay={0.16}>
        <p className="mt-6 text-base leading-relaxed text-zinc-600 sm:text-lg">{lead}</p>
      </FadeUp>
    )}
  </div>
);
